import { IconSettings } from '@tabler/icons-react'
import { ReactNode } from 'react'

import { AstraIcon, AstraSegmentedControl, AstraTooltip } from '~/astra'

import { FormSectionWrapper, FormSectionWrapperProps } from './FormWrapper'

export const ExpertBadge = () => (
    <AstraTooltip tooltipContent="Ekspertfelter – normalt skjult.">
        <AstraIcon icon={IconSettings} backgroundColor="bg-purple-600" backgroundShape="circle" size="medium" color="text-white" />
    </AstraTooltip>
)

type Mode = 'visual' | 'raw'
type ExpertConfigSectionProps = {
    title: string
    description?: string
    mode: Mode
    onModeChange: (mode: Mode) => void
    children?: ReactNode
    size?: FormSectionWrapperProps['size']
}

/**
 * Renders an "expert" config block with a purple E badge and a configurable switch.
 */
export const ExpertConfigSection = ({ title, description, mode, onModeChange, children, size = 'default' }: ExpertConfigSectionProps) => (
    <FormSectionWrapper
        title={title}
        afterTitle={<ExpertBadge />}
        description={description}
        variant="magic"
        size={size}
        titleAction={
            <AstraSegmentedControl
                controlOptions={[
                    { label: 'Visuell', value: 'visual' },
                    { label: 'JSON', value: 'raw' },
                ]}
                value={mode}
                onValueChange={onModeChange}
                size="small"
            />
        }
    >
        {children}
    </FormSectionWrapper>
)
